import React from 'react';
import ResizeObserverPolyfill from 'resize-observer-polyfill';
export const useResize = (ref) => {
    const ResizeObserver = typeof window !== 'undefined' && window.ResizeObserver
        ? window.ResizeObserver
        : ResizeObserverPolyfill;
    const resizeObserver = React.useRef(null);
    const [elementSize, setElementSize] = React.useState({ width: 0, height: 0 });
    React.useEffect(() => {
        resizeObserver.current = new ResizeObserver((entries) => entries.forEach(({ contentRect }) => setElementSize({ width: contentRect === null || contentRect === void 0 ? void 0 : contentRect.width, height: contentRect === null || contentRect === void 0 ? void 0 : contentRect.height })));
        resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.current.observe(ref.current);
        return () => {
            resizeObserver.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);
    return elementSize;
};
